// components/Testimonials.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import temoin1 from '../images/temoin1_80x80.webp';
import temoin2 from '../images/temoin2_80x80.webp';
import temoin3 from '../images/temoin3_80x80.webp';
import temoin4 from '../images/temoin4_80x80.webp';
import './Testimonials.css';

const Testimonials = ({ 
  title: customTitle, 
  subtitle: customSubtitle, 
  testimonials: customTestimonials, 
  isDark = true  // par défaut : fond sombre (comme sur l'accueil)
}) => {
  const { t } = useTranslation();

  // Témoignages par défaut (utilisés sur l'accueil)
  const defaultTestimonials = [
    {
      text: "L'approche pluridisciplinaire d'ATC a révolutionné notre projet d'infrastructure. Leur synergie entre génie civil et digital nous a fait gagner 30% de temps sur la conception.",
      name: 'Pierre Koffi',
      role: 'Directeur de Projet, Groupe Immobilier',
      image: temoin1
    },
    {
      text: 'The smart electrical system designed by ATC allowed us to reduce our energy consumption by 25%. Their expertise in IoT exceeded our expectations.',
      name: 'Dr. Aminata Diallo',
      role: 'Director, Hospital Center',
      image: temoin2
    },
    {
      text: 'The digital platform developed by ATC has transformed our project management. Real-time tracking and BIM integration have eliminated communication delays.',
      name: 'Mohamed Keita',
      role: 'CEO, Mining Company',
      image: temoin4
    },
    {
      text: "Le marketing digital stratégique d'ATC nous a aidé à attirer des investisseurs internationaux. Leur compréhension du secteur de l'ingénierie est exceptionnelle.",
      name: 'Fatou Ndiaye',
      role: 'Directrice Financière, Startup Tech',
      image: temoin3
    }
  ];

  // Utilisation des données personnalisées ou des données par défaut
  const testimonials = customTestimonials || defaultTestimonials;
  const title = customTitle || t('temoignage');
  const subtitle = customSubtitle || t('sous_titre_temoignage');

  return (
    <section className={`testimonials-section ${isDark ? 'dark' : 'light'}`}>
      <div className="container">
        <div className="section-header text-center">
          <h2>{title}</h2>
          <h3>{subtitle}</h3>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-content">
                <i className="fas fa-quote-right"></i>
                <p>{testimonial.text}</p>
              </div>
              <div className="testimonial-author">
                <img src={testimonial.image} alt={testimonial.name} />
                <div>
                  <h6>{testimonial.name}</h6>
                  <span>{testimonial.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;